import React, { useEffect, useState } from "react";
import ImageWithBasePath from "../../core/common/imageWithBasePath";
import { Link, useNavigate, useParams } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useUpdatePasswordMutation } from "../../services/EndPointsApis";
import TextField from "../../core/common/textFields/TextField";

const ResetPassword = () => {
  const route = all_routes;
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const [isConfirmPasswordVisible, setConfirmPasswordVisible] = useState(false);

  const params = useParams();
  const navigate = useNavigate();
  const [forgotPassword, { data, isError, error, isSuccess, isLoading }] = useUpdatePasswordMutation();

  // Validation Schema
  const forgotSchema = Yup.object().shape({
    password: Yup.string()
      .min(8, "Minimum 8 characters")
      .max(16, "Maximum 16 characters")
      .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
      .matches(/[\W_]/, "Password must contain at least one special character")
      .matches(/[0-9]/, "Password must contain at least one number")
      .required("Password is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), ""], "Passwords must match")
      .required("Confirm Password is required"),
  });

  // Formik
  const formik = useFormik({
    initialValues: {
      token: params?.id,
      password: "",
      confirmPassword: "",
    },
    validationSchema: forgotSchema,
    onSubmit: (values) => {
      forgotPassword(values);
    },
  });

  useEffect(() => {
    if (isSuccess) {
      toast.success(data?.message);
      navigate(route.login);
    }
  }, [isSuccess]);

  useEffect(() => {
    if (isError && error) {
      let errorMessage = "Something went wrong";
      if ("data" in error && error.data && typeof error.data === "object" && "message" in error.data) {
        errorMessage = (error.data as { message: string }).message;
      }
      toast.error(errorMessage);
    }
  }, [isError, error]);

  return (
    <div className="account-content">
      <div className="login-wrapper">
        <div className="login-content">
          <div className="d-flex flex-column justify-content-center h-100 w-100">
            <form className="w-100" onSubmit={formik.handleSubmit}>
              <div className="login-user-info">
                <div className="login-logo d-flex justify-content-center">
                  <ImageWithBasePath src="assets/img/logo.svg" alt="Logo" width={220} height={68} />
                </div>
                <div className="row justify-content-center">
                  <div className="col-md-8">
                    <div className="login-heading">
                      <h4>Reset Password</h4>
                      <p>Create a new password</p>
                    </div>

                    {/* Password Field */}
                    <div className="form-wrap">
                      <div className="pass-group">
                        <TextField
                          label="Password"
                          required
                          type={isPasswordVisible ? "text" : "password"}
                          placeholder="Enter password"
                          {...formik.getFieldProps("password")}
                        />
                        <span
                          className={`ti toggle-password ftoggle-password ${isPasswordVisible ? "ti-eye" : "ti-eye-off"}`}
                          onClick={() => setPasswordVisible(!isPasswordVisible)}
                        ></span>
                      </div>
                      {formik.touched.password && formik.errors.password && (
                        <div className="error">{formik.errors.password}</div>
                      )}
                    </div>

                    {/* Confirm Password Field */}
                    <div className="form-wrap">
                      <div className="pass-group">
                        <TextField
                          label="Confirm Password"
                          required
                          type={isConfirmPasswordVisible ? "text" : "password"}
                          placeholder="Confirm password"
                          {...formik.getFieldProps("confirmPassword")}
                        />
                        <span
                          className={`ti toggle-password ftoggle-password ${isConfirmPasswordVisible ? "ti-eye" : "ti-eye-off"}`}
                          onClick={() => setConfirmPasswordVisible(!isConfirmPasswordVisible)}
                        ></span>
                      </div>
                      {formik.touched.confirmPassword && formik.errors.confirmPassword && (
                        <div className="error">{formik.errors.confirmPassword}</div>
                      )}
                    </div>

                    {/* Submit Button */}
                    <div className="form-wrap mt-4">
                      <button className="btn btn-primary" type="submit" disabled={isLoading}>
                        {isLoading ? "Processing..." : "Submit"}
                      </button>
                    </div>

                    <div className="login-form">
                      <h6>
                        Back to{" "}
                        <Link to={route.login} className="hover-a">
                          Log In
                        </Link>
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div className="copyright-text">
            <p className="mb-5">Copyright ©1958 - AIROOM</p>
          </div>
        </div>

        <div className="w-50 login-img"></div>
      </div>
    </div>
  );
};

export default ResetPassword;
